// This is just an example,
// so you can safely delete all default props below

export default {
    button_restart_payment: 'Restart Payment',
    button_search_trip: 'New trip search',
    complete_order_failed_title: 'Error',
    complete_order_failed_desc: 'There are some errors while processing the booking.',
    payment_failed_title: 'Payment not successful',
    payment_failed_desc: 'Your payment was cancelled by you or failed. You can click the "Restart Payment" button to select a new method of payment.',
    reservation_failed_title: 'Not enought capacity or sold out on your selected trip',
    reservation_failed_desc: 'There is no available space on the your selected trips, try with a smaller number of passengers/vehicles or choose another departure. The order cannot be completed for the selected passengers/vehicles.',
    booking_time_passed_title: "Booking time passed",
    booking_time_passed_desc: "The booking time for this departure has now passed, the booking cannot be completed. Please choose another departure/date.",
    already_processed_title: 'Payment already processed',
    already_processed_desc: 'The payment has been processed already, please check email for your order.'
}
